import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {IStripeMultiPaymentMethodsCard} from '../../types/payment.type';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'expiredCardDate',
})
export class ExpiredCardDatePipe implements PipeTransform {
  public transform(card: IStripeMultiPaymentMethodsCard): boolean {
    if (!card || !card.expYear || !card.expMonth) {
      return false;
    }

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    return !(card.expYear > currentYear || (card.expYear === currentYear && card.expMonth >= currentMonth));
  }
}
